import { IRow } from './table';

export enum Language {
  'American English' = 'en-US',
  'Canadian English' = 'en-CA',
  'Canadian French' = 'fr-CA',
  'English - Australia' = 'en-AU',
  'English - United Kingdom' = 'en-GB',
  'English - Singapore' = 'en-SG',
  Japanese = 'ja-JP',
  'German - Switzerland' = 'de-CH',
  'Spanish - Spain' = 'es-ES',
  'English - Ireland' = 'en-IE',
  'Spanish - Mexico' = 'es-MX',
  'Arabic - United Arab Emirates' = 'ar-AE',
  'Danish - Denmark' = 'da-DK',
  'Finnish - Finland' = 'fi-FI',
  'French - France' = 'fr-FR',
  'German - Germany' = 'de-DE',
  'Greek - Greece' = 'el-GR',
  'Italian - Italy' = 'it-IT',
  'Dutch - Netherlands' = 'nl-NL',
  'Norwegian - Norway' = 'nb-NO',
  'Swedish - Sweden' = 'sv-SE',
}

export enum DefaultLanguage {
  'American English' = 'en-us',
  'Canadian English' = 'en-ca',
  'Canadian French' = 'fr-ca',
  'Australian English' = 'en-au',
  'British English' = 'en-gb',
  Japanese = 'ja',
  'Swiss German' = 'de',
  'Spanish (Spain)' = 'es',
  'Irish English' = 'en',
  'Mexican Spanish' = 'es-mx',
  Arabic = 'ar',
  'Danish' = 'da',
  'Finnish' = 'fi',
  'French' = 'fr',
  'German' = 'de',
  'Greek' = 'el',
  'Italian' = 'it',
  'Dutch' = 'nl',
  'Norwegian' = 'nb',
  'Swedish' = 'sv',
}
export enum Country {
  'United States' = 'US',
  Canada = 'CA',
  'United Kingdom' = 'GB',
  Australia = 'AU',
  Singapore = 'SG',
  Japan = 'JP',
  Switzerland = 'CH',
  'United Arab Emirates' = 'AE',
  Mexico = 'MX',
  Ireland = 'IE',
  Spain = 'ES',
  Denmark = 'DK',
  Finland = 'FI',
  France = 'FR',
  Germany = 'DE',
  Greece = 'GR',
  Italy = 'IT',
  Netherlands = 'NL',
  Norway = 'NO',
  Sweden = 'SE',
}

export enum Currency {
  'United States dollar' = 'USD',
  'Canadian dollar' = 'CAD',
  'British pound sterling' = 'GBP',
  'Australian dollar' = 'AUD',
  'Singapore dollar' = 'SGD',
  'Japanese Yen' = 'JPY',
  'Swiss franc' = 'CHF',
  'United Arab Emirates dirham' = 'AED',
  'Mexican peso' = 'MXN',
  'Euro' = 'EUR',
  'Danish krone' = 'DKK',
  'Norwegian krone' = 'NOK',
  'Swedish krona' = 'SEK',
  'No currency' = 'XXX',
}

export enum EnableSendRecurringChargeEmailsOption {
  INHERIT_FROM_TENANT_SELECTION = 'inherit_from_tenant_selection',
  ALWAYS_ENABLE = 'always_enable',
  ALWAYS_DISABLE = 'always_disable',
}

export enum BankDebitMethod {
  SEPA = 'sepa',
  ACH = 'ach',
}

export const allowedCurrenciesPerCountry: Record<Country, Currency[]> = {
  US: [Currency['United States dollar'], Currency['No currency']],
  CA: [Currency['Canadian dollar'], Currency['No currency']],
  GB: [Currency['British pound sterling'], Currency['No currency']],
  AU: [Currency['Australian dollar'], Currency['No currency']],
  SG: [Currency['Singapore dollar'], Currency['No currency']],
  JP: [Currency['Japanese Yen'], Currency['No currency']],
  CH: [Currency['Swiss franc'], Currency['No currency']],
  AE: [Currency['United Arab Emirates dirham'], Currency['No currency']],
  MX: [Currency['Mexican peso'], Currency['No currency']],
  IE: [Currency['Euro'], Currency['No currency']],
  ES: [Currency['Euro'], Currency['No currency']],
  DK: [Currency['Danish krone'], Currency['No currency']],
  FI: [Currency['Euro'], Currency['No currency']],
  FR: [Currency['Euro'], Currency['No currency']],
  DE: [Currency['Euro'], Currency['No currency']],
  GR: [Currency['Euro'], Currency['No currency']],
  IT: [Currency['Euro'], Currency['No currency']],
  NL: [Currency['Euro'], Currency['No currency']],
  NO: [Currency['Norwegian krone'], Currency['No currency']],
  SE: [Currency['Swedish krona'], Currency['No currency']],
};

export const CurrencySymbol: Record<Currency, string> = {
  USD: '$',
  CAD: '$',
  AUD: '$',
  SGD: '$',
  GBP: '£',
  JPY: '¥',
  CHF: 'CHF',
  AED: 'د.إ',
  MXN: '$',
  EUR: '€',
  DKK: 'kr',
  NOK: 'kr',
  SEK: 'kr',
  XXX: 'X',
};

export enum GateGeoCheckInByDistance {
  'Inherit from Tenant' = 'inherit_from_tenant',
  'Gate by check-in distance' = 'enable_distance_gating',
  'Allow check-in from anywhere' = 'disable_distance_gating',
}

export enum EmailMarketingOption {
  'Inherit from Tenant' = 'inherit_from_tenant',
  'Opt In' = 'default_opt_in',
  'Opt Out' = 'default_opt_out',
}

export enum TaxPricingOption {
  'Inherit from tenant' = 'inherit_from_tenant',
  'Always Include Tax' = 'always_include',
  'Always Exclude Tax' = 'always_exclude',
}

export enum IsRemainingSpotCountPublicOption {
  'Inherit from Tenant Selection' = 'inherit_from_tenant_selection',
  'Always Show' = 'always_show',
  'Always Hide' = 'always_hide',
}

export enum EnableSendRecurringChargeEmailsOption {
  'Inherit from Tenant Selection' = 'inherit_from_tenant_selection',
  'Always Enable' = 'always_enable',
  'Always Disable' = 'always_disable',
}

export enum EnablePreCheckedNewsletterSubscriptionOption {
  'Inherit from Tenant' = 'inherit_from_tenant',
  'Opt In' = 'default_opt_in',
  'Opt Out' = 'default_opt_out',
}

export interface Location {
  Name: string; // Required field
  RegionName: string; // Required field
  PrimaryLanguage: Language;
  DefaultLanguage: Language;
  Country: Country;
  AddressLine1: string; // Required field
  AddressLine2?: string;
  AddressCity: string; // Required field
  StateProvince: string; // Required field
  PostalCode: string; // Required field
  PhoneNumber: string; // Required field
  EmailAddress: string; // Required field
  ChargeBackEmail: string; // Required field
  CurrencyCode: Currency;
  IsWaitlistPositionPublic?: boolean;
  IsWaitlistCountPublic?: boolean;
  IsRemainingSpotCountPublic: IsRemainingSpotCountPublicOption; // Required field
  EnableChangeSpots?: boolean;
  EnableClasspass?: boolean;
  EnableThirdPartyChangeSpots?: boolean;
  DailyReservationLimit?: string;
  EnableGeoCheckIn?: boolean;
  GateGeoCheckInByDistance: GateGeoCheckInByDistance;
  GeoCheckInDistance?: number;
  EnableRoyaltyFeePlatform?: boolean;
  PrimaryClassroom?: string;
  EnablePreCheckedNewsletterSubscription: EnablePreCheckedNewsletterSubscriptionOption;
  LateCancelFee?: number;
  NoShowFee?: number;
  UseTaxInclusivePricing: TaxPricingOption;
  BusinessNumber?: string;
  StripeAccountId: string; // Required field
  StripeStatementDescriptor?: string;
  PercentageFee?: number;
  FlatFee?: number;
  TerminalPercentageFee?: number;
  TerminalFlatFee?: number;
  BankDebitMethod?: BankDebitMethod;
  DirectDebitPercentageFee?: number;
  DirectDebitFlatFee?: number;
  StripeTransactionAmounts: number; // Required field
  EnableSendRecurringChargeEmails: EnableSendRecurringChargeEmailsOption; //Required field
}

interface Data {
  type: string;
  id: string;
}

export interface LocationDetails {
  data: {
    type: string;
    id: string;
    attributes: {
      name: string;
      legal_entity: string;
      timezone: string;
      address_line1: string;
      address_line2: string;
      address_line3: string;
      address_sorting_code: null | string;
      city: string;
      state_province: string;
      postal_code: string;
      phone_number: string;
      description: null | string;
      email_address: string;
      user_has_turf_access: boolean;
      latitude: string;
      longitude: string;
      primary_language: string;
      default_language: string;
      listed: boolean;
      currency_code: string;
      daily_pending_reservation_limit: string;
      enable_geo_check_in: boolean;
      class_pass_status: string;
      is_newsletter_subscription_pre_checked: boolean;
      is_waitlist_position_public: boolean;
      is_waitlist_count_public: boolean;
      enable_change_spots: boolean;
      enable_third_party_change_spots: boolean;
      enable_royalty_fee_platform: boolean;
      geo_check_in_distance: null | number;
      gate_geo_check_in_by_distance: string;
      business_number: null | string;
      formatted_address: string[];
      late_cancel_fee: string;
      no_show_fee: string;
      use_tax_inclusive_pricing: string;
      enable_send_recurring_charge_emails: string;
    };
    relationships: {
      region: {
        data: Data;
      };
      classrooms: {
        data: Data[];
      };
      partner: {
        data: Data;
      };
      default_product_collection: {
        data: Data;
      };
      site: {
        data: Data;
      };
      quick_sale_product_collection: {
        data: Data;
      };
      addons_product_collection: {
        data: Data;
      };
    };
  };
  included: {
    type: string;
    id: string;
    attributes: {
      name: string;
      listed: boolean;
      gate_geo_check_in_by_distance?: boolean;
      geo_check_in_distance?: number;
    };
    relationships: {
      site: {
        data: Data;
      };
      locations: {
        data: Data[];
      };
    };
  }[];
  classrooms: Classrooms;
  buy_pages: BuyPage[];
}

export interface Classrooms {
  data: ClassroomData[];
  included: {
    type: string;
    id: string;
    attributes: {
      name: string;
      listed: boolean;
    };
  }[];
}

export interface ClassroomData {
  type: string;
  id: string;
  attributes: ClassroomDetailsAttributes;
  relationships: {
    layouts: {
      data: { type: string; id: string }[];
    };
  };
}

export interface ClassroomDetailsAttributes {
  name: string;
  historicalClassCount: number;
  listed: boolean;
  upcomingClassCount: number;
}

export interface ClassroomTransformedResponse {
  id: string;
  name: string;
  listed: boolean;
  activeLayouts: number;
}

export interface BuyPage {
  id: string;
  type: string;
  attributes: {
    name: string;
    slug: string;
    collection_type: string;
  };
}

interface Data {
  type: string;
  id: string;
}
export interface ProductClassesData {
  data: ProductClassData[];
}
export interface ProductClassData {
  type: string;
  id: string;
  attributes: {
    name: string;
    slug: string;
  };
}
export interface TaxesData {
  data: TaxData[];
}
export interface TaxData {
  product_class_name: string;
  product_class_slug?: string;
  min_applicable?: string | null;
  max_applicable?: string | null;
  tax_rate_name: string;
  tax_rate: string;
  tax_id: string;
  id: string;
}

export type DefaultTaxProductClassParams = {
  include: string;
  page: number;
  page_size: number;
  partner: string;
};

export interface ContainerProps {
  disabled?: boolean;
  error?: string;
}

interface LocationDetailsError {
  row: string;
  locationName: string;
  columnInError: string;
  error: string;
}

interface ImportLocationsDetails {
  errors: LocationDetailsError[];
  locations: {
    created: string[] | null;
    updated: string[] | null;
    rest: string[] | null;
  };
}

export interface LocationApiResponse {
  addons_product_collection: Data;
  address_line1: string;
  address_line2: string;
  address_line3: string;
  address_sorting_code: null | string;
  business_number: string;
  city: string;
  class_pass_status: string;
  classrooms: Data[];
  created_at: string;
  currency_code: string;
  daily_pending_reservation_limit: number;
  daily_reservation_limit: null | number;
  default_language: string;
  default_product_collection: Data;
  description: null | string;
  email_address: string;
  enable_change_spots: boolean;
  enable_geo_check_in: boolean;
  enable_pre_checked_newsletter_subscription: string;
  enable_royalty_fee_platform: boolean;
  enable_send_recurring_charge_emails: string;
  enable_third_party_change_spots: boolean;
  formatted_address: string[];
  gate_geo_check_in_by_distance: string;
  geo_check_in_distance: number;
  id: number;
  is_remaining_spot_count_public: string;
  is_waitlist_count_public: boolean;
  is_waitlist_position_public: boolean;
  latitude: string;
  listed: boolean;
  longitude: string;
  name: string;
  partner: Data;
  phone_number: string;
  postal_code: string;
  primary_language: string;
  quick_sale_product_collection: Data;
  region: Data;
  site: Data;
  state_province: string;
  status: string;
  stripe_location_id: null | string;
  timezone: string;
  updated_at: string;
  use_tax_inclusive_pricing: string;
}

export interface ImportLocationsApiResponse {
  data: ImportLocationsResponse;
}

export interface ImportLocationsResponse {
  data?: LocationApiResponse[];
  details?: ImportLocationsDetails;
}

export interface CheckExistingLocationRequest {
  location_name: string;
  region_name: string;
}

export interface CheckExistingLocationResponse {
  existing_locations?: string[];
  new_locations?: string[];
}

export interface GetPresignedUrlPayload {
  filename: string;
  timeframe: string;
  tenant: string;
  contentMD5: string;
}

export interface GetPresignedUrlResponse {
  data: { url: string; username: string };
}

export interface FileDetails {
  datetime: string;
  filename: string;
  username: string;
}

export interface FileListData {
  data: {
    file_list: FileDetails[] | IRow;
    user_list: string[];
  };
}

export interface FileStorageLink {
  data: string;
}
